export default __webpack_public_path__ + "38527b9b706333cec69b184c0dfec3f3.png";